import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';

const BASE_PATH = '/permission';
export const PERMISSION_ROUTES = {
  index: BASE_PATH,
  groups: `${BASE_PATH}/groups`,
  accounts: `${BASE_PATH}/accounts`,
  batchAssign: `${BASE_PATH}/batch-assign`,
} as const;

type PermissionRouteKey = keyof typeof PERMISSION_ROUTES;

export const PERMISSION_LAYOUT_ROUTE_ID = '/permission-layout';
export const PERMISSION_ROUTE_IDS = {
  index: `/${AUTH_ROUTE_ID}${PERMISSION_LAYOUT_ROUTE_ID}${PERMISSION_ROUTES.index}`,
  groups: `/${AUTH_ROUTE_ID}${PERMISSION_LAYOUT_ROUTE_ID}${PERMISSION_ROUTES.groups}`,
  accounts: `/${AUTH_ROUTE_ID}${PERMISSION_LAYOUT_ROUTE_ID}${PERMISSION_ROUTES.accounts}`,
  batchAssign: `/${AUTH_ROUTE_ID}${PERMISSION_LAYOUT_ROUTE_ID}${PERMISSION_ROUTES.batchAssign}`,
} as const satisfies Record<PermissionRouteKey, string>;
